import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { Partnership } from './partnership.model';

@Injectable({providedIn: 'root'})
export class PartnershipService extends BaseService<Partnership> {
      
    constructor(
        protected injector: Injector,
    ){
        super(injector);
        this.copyJsonDataToObjectFunction=Partnership.fromJsonToObject
        this.urls={getAllUrl:'partnership',saveUrl:'regParceria',updateUrl:'up-parceria',deleteUrl:'dst-parceria'}
    }

    
}